import { ApiPermission } from "@bvhi/backend-api";
import { useCallback } from "react";
import { BVHIRoute } from "../config/navigation";
import { useAuthContext } from "../context/use-auth-context";

export const usePermissions = () => {
  const { currentUser } = useAuthContext();

  const canNavigateTo = useCallback(
    (route: BVHIRoute): boolean => {
      if (!route.permissions) return true;
      if (!currentUser?.permissions) return false;

      return (
        route.permissions.filter((permission) => permission && currentUser.permissions.includes(permission as ApiPermission)).length > 0
      );
    },
    [currentUser]
  );

  const hasPermissionTo = useCallback(
    (permissions: (ApiPermission | undefined)[]): boolean => {
      if (!currentUser?.permissions) return false;

      return permissions.filter((permission) => permission && currentUser.permissions.includes(permission as ApiPermission)).length > 0;
    },
    [currentUser]
  );

  return { canNavigateTo, hasPermissionTo };
};
